import { Component, computed, input } from '@angular/core';

@Component({
  selector: 'rid-progress-bar',
  imports: [],
  templateUrl: './rid-progress-bar.html',
})
export class RidProgressBar {
  steps = input.required<number>();
  progress = input.required<number>();

  ticks = computed(() => {
    const ticks: 'tick'[] = [];
    for (let i = 0; i < this.steps() - 1; i++) {
      ticks.push('tick');
    }
    return ticks;
  });
}
